export const initScrollIndicator = () => {
  const scrollIndicator = document.getElementById('scrollIndicator');
  
  if (!scrollIndicator) return;

  const updateScrollIndicator = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;
    
    scrollIndicator.style.setProperty('--scroll-width', `${scrollPercent}%`);
  };

  window.addEventListener('scroll', updateScrollIndicator);
  window.addEventListener('resize', updateScrollIndicator);
  
  // Initial call
  updateScrollIndicator();
}; 